import(/* webpackMode: "eager", webpackExports: ["ConfigProvider","App"] */ "__barrel_optimize__?names=App,ConfigProvider!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/(grouped)/layout.module.css");
